import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CartPage from "./components/Cart";
import ProductDetail from "./components/ProductDetail";
import Checkout from "./components/checkout";
// import Navbar from "./components/Navbar";
// import Footer from "./components/Footer";
// import Sidebar from "./components/Sidebar"; 
import Dashboard from "./admin/Dashboard";
// import Products from "./admin/Products";
// import Orders from "./admin/Orders";
// import AdminProduct from "./admin/AdminProducts";
// import Button from "./components/demobutton";
import Users from "./admin/Users";
import OrderManage from "./admin/Ordermanage";
import CategoryForm from "./admin/CategoryForm";
import BannerManager from "./admin/BannerManager";
import CMSManager from "./admin/CMSManager";
import SettingsManager from "./admin/SettingsManager";
import AdminSettings from "./admin/AdminSettings";
import NotificationsManager from "./admin/NotificationManager";
import AuthPage from "./auth/authPage";
// import UserProdcts from "./admin/UserProducts";
import TransactionHistory from "./admin/TransactionHistory";
// import ProfilePage from "./admin/Profile";
// import VendorProfile from "./admin/vendorprofile";
// import VendorUser from"./vendor/vendoruser";
import VendorProducts from "./admin/product/VendorProducts";
import { AuthProvider } from './context/AuthContext';
import AdminLayout from "./auth/AdminLayout";
import UnauthorizedPage from "./auth/UnauthorizedPage";
import VendorLayout from "./auth/VendorLayout";
import ProfilePage from "./admin/profile/ProfilePage";
import AdminProducts from "./admin/product/AdminProducts";
import CategoryPage from "./components/filterproducts/CategoryPage";
import { CheckoutProvider } from './components/CheckoutContext';
// import TrackOrders from "./components/trackorders";
// import MyAddress from "./components/Myaddress";

import TrackOrders from "./components/orders/TrackOrders";
import UserLayout from "./auth/UserLayout";
import UserProfilePage from "./admin/profile/UserProfile";
import VendorDashboard from "./admin/users/VendorDashboard";
import VendorProfilePage from "./admin/profile/VendorProfile";
import VendorUserManagement from "./admin/users/VendorsUsersManagement";
import VendorOrders from "./admin/users/VendorOrders";
import TransactionReport from "./admin/report/TransactionReport";
import RewardsReport from "./admin/report/RewardPage";
import RewardSequencesTable from "./admin/report/SequenceTable";
import PaymentStatus from "./admin/payment/PaymentStatus";
import Invoice from "./components/orders/Invoice";
import Rewards from "./components/Rewards";



const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <>
            {/* <Navbar /> */}
            {/* <Sidebar/> */}
          <CheckoutProvider>

          <AuthProvider>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<AuthPage />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              <Route path="/category/:categoryId" element={<CategoryPage />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/invoice" element={<Invoice />} />
              
             

              <Route path="/admin" element={<AdminLayout />} >
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="Users" element={<Users />} />
                <Route path="category" element={<CategoryForm />} />
                <Route path="banner" element={<BannerManager />} />
                <Route path="CMS" element={<CMSManager />} />
                <Route path="Settings" element={<SettingsManager />} />
                <Route path="AdminProfile" element={<AdminSettings />} />
                <Route path="Notification" element={<NotificationsManager />} />
                <Route path="adminproduct" element={<AdminProducts/>} />
                <Route path="admintrans" element={<TransactionHistory />} />
                <Route path="profile/:userId" element={<ProfilePage />} />
                <Route path="OrderManage" element={<OrderManage/>} />
                <Route path="trans" element={<TransactionReport/>} />
                 <Route path="rewards" element={<RewardsReport/>} />
                  <Route path="table" element={<RewardSequencesTable />} />
              </Route>

              <Route path="/vendor" element={<VendorLayout />} >
                <Route path="dashboard" element={<VendorDashboard />} />
                <Route path="vendoruser" element={<VendorUserManagement />} />
                <Route path="VendorProducts" element={<VendorProducts />} />
                <Route path="vendorprofile/:userId" element={<VendorProfilePage />} />
                <Route path="OrderManage" element={<VendorOrders/>} />
              </Route>
           
              <Route path="/user" element={<UserLayout />} >
                <Route path="checkout/:userId" element={<Checkout />} />
                <Route path="cart/:userId" element={<CartPage />} />
                <Route path="trackorders/:userId" element={<TrackOrders />} />
                <Route path="userprofile/:userId" element={<UserProfilePage />} />
                <Route path="checkout" element={<Checkout />} />
                <Route path="paymentstatus" element={<PaymentStatus />} />
                <Route path="rewards/:userId" element={<Rewards />} />
               
              </Route>

         
          
              <Route path="*" element={<UnauthorizedPage link="/" />} />

            </Routes></AuthProvider></CheckoutProvider>

            {/* <Footer /> */}
          </>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
